export enum BusinessComplianceQueryKeys {
  BUSINESS_METRICS = "businessMetrics",
  BUSINESSES_LIST = "businessesList",
  BUSINESS_DETAILS = "businessDetails",
  BUSINESS_APPROVAL = "businessApproval",
  BUSINESS_REJECTION = "businessRejection",
}
